import { connect } from 'react-redux';
import { cartSelector, uiselector } from '../selector';
import Summary from '../components/summary';
import { toggleOrderSummary } from '../actions';

export default connect(
  state => {
    const { showOrderSummary } = uiselector('showOrderSummary')(state);
    return {
      showOrderSummary,
      ...cartSelector(state),
    };
  },
  dispatch => ({
    toggleOrderSummary: () => dispatch(toggleOrderSummary()),
  })
)(Summary);



// WEBPACK FOOTER //
// ../shop_main/containers/summary.js